import React, { useEffect, useReducer, useState, useMemo } from "react"
import { get, isEqual, find, map } from "lodash"

import { InterestTemplate } from "components/templates/top/interest"
import {
  requestPriceListAPIs,
  usePriceList,
  countryCodeList,
} from "components/actions/priceList"
import { APIResponse } from "redux/apis/types"
import { withRouter, WithRouterProps } from "react-router"
import { getCountryIcon } from "utils/util"
import ClassNames from "classnames"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

const initialInterestListState = {
  name: "Top.GB.Main",
}

const initialState = {
  ResultList: [{}, {}, {}, {}, {}],
}

export const Interest: WithRouterProps<React.FC> = withRouter(
  ({ location }) => {
    const [interestListState, usePriceListReducer] = useReducer(
      usePriceList,
      initialInterestListState
    )
    const [interestList, setInterestList] = useState<APIResponse.Res>(
      initialState
    )
    const [interestEachCountryList, setInterestEachCountryList] = useState<
      APIResponse.Res
    >(initialState)
    const [countryList, setCountryList] = useState([])
    const [refreshFlag, setRefreshFlag] = useState(false)
    const isPageLoading = useSelector(
      (state: { PageLoad: LoadStateType }) => state.PageLoad.load
    )
    const loadResistId = useMemo(() => uuid(), [])

    const setCountry = (data: APIResponse.Res) => {
      const resultList = get(data, "ResultList")
      const _countryList = map(resultList, (data: object, i: number) => {
        const icon = getCountryIcon(data)
        return {
          id: i,
          name: get(data, "SymbolName").split("１０年")[0],
          icon: ClassNames("icon-solid ", icon),
        }
      })
      setCountryList(_countryList)
    }

    useEffect(() => {
      store.dispatch(pageLoadRegist(loadResistId, true))
      requestPriceListAPIs(interestListState)
        .then((data: APIResponse.Res) => {
          setInterestList(data)
          setCountry(data)
          store.dispatch(pageLoadRegist(loadResistId, false))
        })
        .catch(() => {
          return
        })
    }, [])

    useEffect(() => {
      if (!isEqual(interestList, initialState)) {
        store.dispatch(pageLoadRegist(loadResistId, true))
        const resultList = get(interestList, "ResultList")
        const currentData = get(location.state, "rowData") || resultList[0]
        const securityType = get(currentData, "SecurityType")
        const countryData = find(countryCodeList, data => {
          return data.securityType === securityType
        })
        requestPriceListAPIs({
          name: countryData.countryCode,
        })
          .then((data: APIResponse.Res) => {
            store.dispatch(pageLoadRegist(loadResistId, false))
            setInterestEachCountryList(data)
          })
          .catch(() => {
            return
          })
      }
    }, [interestList])

    //ページ更新
    useEffect(() => {
      if (isPageLoading) {
        store.dispatch(pageLoadRegist(loadResistId, true))
        requestPriceListAPIs(interestListState)
          .then((data: APIResponse.Res) => {
            setInterestList(data)
            setCountry(data)
            store.dispatch(pageLoadRegist(loadResistId, false))
          })
          .catch(() => {
            return
          })
      }
    }, [isPageLoading])

    useEffect(() => {
      if (refreshFlag) {
        store.dispatch(pageLoadRegist(loadResistId, true))
        requestPriceListAPIs(interestListState)
          .then((data: APIResponse.Res) => {
            setInterestList(data)
            setCountry(data)
            store.dispatch(pageLoadRegist(loadResistId, false))
          })
          .catch(() => {
            return
          })

        setRefreshFlag(false)
      }
    }, [refreshFlag])

    return (
      <InterestTemplate
        interestList={interestList}
        interestEachCountryList={interestEachCountryList}
        setInterestEachCountryList={setInterestEachCountryList}
        interestListAction={usePriceListReducer}
        transitionData={get(location.state, "rowData")}
        countryList={countryList}
        setRefreshFlag={setRefreshFlag}
      />
    )
  }
)
